import {Authenticated} from './middleware'

export default [
  {
    name: 'lightVisit',
    path: '/',
    redirect: {name: 'lightVisit.open'},
    component: () => import ('../../views/cpanel/lightVisit'),
    meta: {
      title: 'Доступные сессии',
      back: 'cpanel.dashboard',
      middleware: Authenticated
    },
    children: [
      {
        name: 'lightVisit.open',
        path: 'open',
        component: () => import ('../../views/cpanel/lightVisit/Open'),
        meta: {
          title: 'Доступные сессии',
          back: 'cpanel.dashboard',
          middleware: Authenticated,
          permission: 'can.manage.users'
        }
      }
    ]
  }

];

